"use strict";

exports.__esModule = true;
exports.timeoutType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line import/prefer-default-export
var timeoutType = _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
  enter: _propTypes["default"].number,
  exit: _propTypes["default"].number
})]);

exports.timeoutType = timeoutType;